import type { Util } from '../../types/util';

const basePaper: Util.VariantCSSKeys<PaperVariantsType> = {
  default: {
    background: 'white',
    borderStyle: 'solid',
    borderWidth: '1px',
    borderColor: 'coolGrey.10',
    borderRadius: 'paper',
    padding: 's40',
  },
  raised: {
    background: 'white',
    borderStyle: 'solid',
    borderWidth: '1px',
    borderColor: 'coolGrey.10',
    borderRadius: 'paper',
    boxShadow: '20',
    padding: 's40',
  },
  raisedLow: {
    background: 'white',
    borderStyle: 'solid',
    borderWidth: '1px',
    borderColor: 'coolGrey.10',
    borderRadius: 'paper',
    boxShadow: '10',
    padding: 's40',
  },
};

const paper: Util.VariantKeyModes<PaperVariantsType> = {
  products: {
    chart: basePaper,
    chartblog: basePaper,
    co: basePaper,
    edu: basePaper,
    scale: basePaper,
    spark: basePaper,
  },
};

export type PaperVariantsType = 'default' | 'raised' | 'raisedLow';
export const paperVariants = Object.keys(basePaper) as PaperVariantsType[];

export default paper;
